import React, { useEffect, useState } from "react";

const CongratulationsModal = ({ isOpen, onClose, gradingData }) => {
  const [showButton, setShowButton] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      const delay = setTimeout(() => {
        setShowButton(true);
        setIsLoading(false);
      }, 2000); // simulate processing delay
      return () => clearTimeout(delay);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-[2rem] shadow-2xl w-[90%] max-w-[500px] p-8 text-center animate-[popUp_0.4s_ease-out] relative overflow-hidden">
        
        {/* Confetti Emoji */}
        <div className="text-[3rem] mb-2 animate-bounce">🎉</div>

        {/* Title */}
        <h2 className="text-3xl font-bold text-[#333] font-inter mb-2">Congratulations!</h2>
        <p className="text-md text-gray-600 font-inter mb-4">
          Your answer has been submitted successfully!
        </p>

        {/* Grading Results */}
        {isLoading ? (
          <div className="flex justify-center items-center my-6">
            <div className="w-6 h-6 border-4 border-dashed rounded-full animate-spin border-black border-t-transparent"></div>
          </div>
        ) : gradingData ? (
          <div className="bg-gray-50 rounded-xl p-4 mt-4 mb-6 shadow-inner text-left text-sm font-inter">
            <p className="mb-2">
              <strong className="text-green-600">+{gradingData.points} Points</strong>
            </p>
            <p className="text-gray-700 whitespace-pre-line">
              {gradingData.feedback}
            </p>
          </div>
        ) : null}

        {/* Button */}
        {showButton && (
          <button
            onClick={onClose}
            className="mt-4 px-6 py-2 rounded-full bg-black text-white font-semibold font-inter text-sm hover:bg-neutral-800 transition-all active:scale-95"
          >
            Ok
          </button>
        )}

        {/* Decorative Confetti */}
        <div className="absolute -top-10 -right-10 text-[4rem] animate-spin-slow">✨</div>
        <div className="absolute -bottom-10 -left-10 text-[3rem] animate-spin-slow-reverse">🌟</div>

        {/* Animations */}
        <style>{`
          @keyframes popUp {
            0% { transform: scale(0.8); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }

          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          @keyframes spin-slow-reverse {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(-360deg); }
          }

          .animate-spin-slow {
            animation: spin-slow 12s linear infinite;
          }

          .animate-spin-slow-reverse {
            animation: spin-slow-reverse 10s linear infinite;
          }
        `}</style>
      </div>
    </div>
  );
};

export default CongratulationsModal;
